<template>

    <div>

        <b-card>

            <b-row class="mb-2">

                <b-col lg="4" class="my-1">

                    <b-form-select v-model=" unread ">

                        <option value="">-- All Messages --</option>
                        <option value="0">Read Messages</option>
                        <option value="1">Unread Messages</option>
                    </b-form-select>
                </b-col>
                <b-col lg="4" class="my-1" v-if=" !isCarrierManager ">

                    <b-form-select v-model=" tag ">

                        <option value="">-- No Tag --</option>
                        <option value="ltcg">Tagged LTCG</option>
                        <option value="jtr">Tagged JTR</option>
                    </b-form-select>
                </b-col>
                <b-col lg="4" class="my-1" v-if=" !scopeduser ">

                    <carrier-dropdown v-model=" ltc_carrier_id " :role=" role "></carrier-dropdown>
                </b-col>
                <b-col lg="4" class="my-1" v-if=" !scopeduser ">

                    <b-form-input v-model=" policy_number " placeholder="-- Claimant Policy Number --"></b-form-input>
                </b-col>
                <b-col lg="4" class="my-1">

                    <b-form-select v-model=" roleFilter ">

                        <option value="">-- Filter by Role --</option>
                        <option value="client">Claimant</option>
                        <option value="caregiver">Provider</option>
                        <option value="carrier_manager">Carrier</option>
                        <option value="office_user">LTCG</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-3">

                <b-col sm="12" class="d-flex align-items-center justify-content-between">

                    <p class="m-0 mt-1">Total: {{ totalRows }}</p>
                    <div class="d-flex align-items-center">

                        <b-button variant="success" @click=" createScoped() " v-if=" scopeduser " class="mr-1">Create New</b-button>
                        <b-button variant="info" @click=" loadTable() ">Generate List</b-button>
                    </div>
                </b-col>
            </b-row>

            <div class="table-responsive">

                <b-table bordered striped hover show-empty
                    :items=" items "
                    :fields=" fields "
                    :current-page=" currentPage "
                    :per-page=" 0 "
                    :sort-by.sync=" sortBy "
                    :sort-desc.sync=" sortDesc "
                    :busy=" loading "
                >
                    <template v-slot:cell(user_name)="row">

                        <span v-text="row.item.user_name" :class="row.item.status == 'open' ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(user_role)="row">

                        <span v-text="mapRole(row.item.user_role)" :class="row.item.status == 'open' ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(subject)="row">

                        <span v-text="row.item.subject" :class="row.item.status == 'open' ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(status_display)="row">

                        <span v-text="row.item.status_display" :class="row.item.status == 'open' ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(updated_at)="row">
                      <utc-time
                          :time="row.item.updated_at"
                          timezone="America/Chicago"
                          :class="row.item.status == 'open' ? 'unread' : null"
                      />
                    </template>
                    <template v-slot:cell(actions)="row">

                        <b-btn size="sm" @click="viewMessage(row.item)">View</b-btn>
                    </template>
                </b-table>
            </div>

            <b-row>

                <b-col lg="6" >

                    <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                </b-col>
                <b-col lg="6" class="text-right">

                    {{ paginationText }}
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

    import FormatsDates from "../../mixins/FormatsDates";
    import PaginatedTable from "../../mixins/PaginatedTable";
    import UsesRole from "../../mixins/UsesRole";
    import ScopesToUser from "../../mixins/ScopesToUser";

    export default {

        mixins: [ FormatsDates, PaginatedTable, UsesRole, ScopesToUser ],

        data() {

            return {

                roleFilter     : '',
                unread         : '',
                tag            : '',
                ltc_carrier_id : '',
                policy_number  : '',

                fields : [
                    {
                        key: 'user.name',
                        label: 'User',
                        sortable: true,
                    },
                    {
                        key: 'user.role_type',
                        label: 'Role',
                        sortable: true,
                    },
                    {
                        key: 'subject',
                        label: 'Subject',
                        sortable: true,
                    },
                    { 
                        key: 'status_display',
                        label: 'Status',
                        sortable: true,
                    },
                    {
                        key: 'updated_at',
                        label: 'Last Update',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    }
                ],
            }
        },

        computed: {

            baseUrl(){ return `/${this.controller}/messages`; },
            appliedFilters(){ return `?ltc_carrier_id=${this.ltc_carrier_id}&unread=${this.unread}&tag=${this.tag}&roleFilter=${this.roleFilter}`; },
            unwatchedFilters(){ return `&policy_number=${this.policy_number}&scopedUser=${this.scopeduser}`; }
        },

        methods: {

            viewMessage( message ) {

                window.open( `/${this.controller}/messages/${message.id}`, '_blank' );
            }
        },

        mounted() {

        },
    }
</script>

<style>

    .unread { font-weight: 600; }
</style>